// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"_1JzQew","desktop":"_1NWR-G","row":"_3dbzEK","mobile":"_2nkYcO","teaser":"_2qArYl"};